import React, { useEffect, useState } from "react";
import 'bootstrap/dist/css/bootstrap.min.css'
import styles from "../../styles/tenant.module.css"
import { useFieldArray, useForm } from 'react-hook-form'
import { gql, useMutation, useQuery } from "@apollo/client";
import { GET_API_CONFIG_BY_ID, GET_DATA_INTEGRATION_BY_ID, GET_TENANT_BY_ID, UPDATE_TENANT_API_CONFIG, UPDATE_TENANT_DATA_INT } from "../../graphql/TenantQueries";
import ErrorDisplay from "../common/ErrorDisplay";


function EditDataIntModal({ setOpenEditDataIntModal, setOpenActionModal, fieldData }: any) {
    const { register, handleSubmit, formState: { errors }, control, watch } = useForm({})
    const [updateTenantDataInt, { loading: mutationLoading, error: mutationError }] = useMutation(UPDATE_TENANT_DATA_INT, {
        refetchQueries: [
          {query: GET_DATA_INTEGRATION_BY_ID, variables: { id: fieldData }  }, 
          'getDataIntegrationByTenantId' 
        ],
      });
    const { loading: tenantLoading, error: tenantError, data: tenantData } = useQuery(GET_TENANT_BY_ID, { variables: { id: fieldData } })
    const { loading, error, data } = useQuery(GET_DATA_INTEGRATION_BY_ID, { variables: { id: fieldData } })

    const formSubmit = async (formData: any) => {
        try {
            const promises = formData.input.map((el: any) => {
                const id = el.esri._id;
                delete el.esri._id
                el.esri.layers?.forEach((e:any) => {
                    e.group = parseInt(e.group)
                    e.layerNumber = parseInt(e.layerNumber)
                })
                return updateTenantDataInt({ variables: { id: id, input: { ...el, tenant: { name: `${tenantData.getTenantById.name}`, id: `${tenantData.getTenantById.id}`, displayName: `${tenantData.getTenantById.displayName}` } } } });
            });
            
            await Promise.all(promises);
            setOpenActionModal(false);
            setOpenEditDataIntModal(false);
        } catch (error) {
            console.error('Error updating data integration:', error);
        }
    }



    if (loading) return <h3>Loading...</h3>
    return (
        <>
            <div className={styles["formModalContainer"]}>
                <div className={styles["title"]}>
                    <h1>Edit Tenant Data Integration</h1>
                </div>
                {data?.getDataIntegrationByTenantId &&
                    <div className={styles["body"]}>

                        <form onSubmit={handleSubmit(formSubmit)}>
                            {data?.getDataIntegrationByTenantId.length === 0 && <h3 style={{ textAlign: 'center', paddingBottom: '100px' }}>No Data Integration for this Tenant</h3>}
                            {data.getDataIntegrationByTenantId.length > 0 && <><h3 style={{display: 'flex', paddingTop: '30px'}}>ESRI</h3><hr /></>}
                            {data.getDataIntegrationByTenantId?.map((el: any, idx: number) =>
                                


                                <>
                                    <label className={styles["label"]}>Application Secret</label>
                                    <input {...register(`input[${idx}].esri.appSecret`)} className={styles["input"]} defaultValue={el.esri.appSecret}></input>
                                    <input {...register(`input[${idx}].esri._id`)} className={styles["input"]} defaultValue={el._id} type={'hidden'}></input>

                                    <h6 style={{ display: "flex", paddingTop: "20px" }}>Layers</h6>

                                    {el?.esri.layers && el.esri.layers.map((layerEl: any, index: number) =>
                                        <>
                                            <label className={styles["label"]}>Layer Name</label>
                                            <input {...register(`input[${idx}].esri.layers[${index}].layerName`)} className={styles["input"]} defaultValue={layerEl.layerName}></input>
                                            <label className={styles["label"]}>Display Name</label>
                                            <input {...register(`input[${idx}].esri.layers[${index}].displayName`)} className={styles["input"]} defaultValue={layerEl.displayName}></input>
                                            <div>
                                                <label className={styles["label"]}>Layer Number</label>
                                                <input {...register(`input[${idx}].esri.layers[${index}].layerNumber`)} className={styles["input"]} defaultValue={layerEl.layerNumber}></input>
                                                <label className={styles["label"]}>Layer Field Mapping</label>
                                                <input {...register(`input[${idx}].esri.layers[${index}].layerFieldMapping`)} className={styles["input"]} defaultValue={layerEl.layerFieldMapping}></input>
                                            </div>
                                            <div>
                                                <label className={styles["label"]}>Tags</label>
                                                <input {...register(`input[${idx}].esri.layers[${index}].tags`)} className={styles["input"]} defaultValue={layerEl.tags}></input>
                                                <label className={styles["label"]}>Group</label>
                                                <input {...register(`input[${idx}].esri.layers[${index}].group`)} className={styles["input"]} defaultValue={layerEl.group}></input>
                                            </div>
                                            <hr/>
                                        </>
                                    )}
                                </>
                            )}
                            <div>
                                <button onClick={() => {
                                    setOpenEditDataIntModal(false);
                                }} className={styles["button"]}>
                                    Cancel
                                </button>
                                {data.getDataIntegrationByTenantId.length > 0 && <input type='submit' className={styles["button"]} />}
                            </div>
                        </form>
                    </div>
                }
            </div>
            <ErrorDisplay error={mutationError} />
        </>
    )
}

export default EditDataIntModal;